import styles from './CollapseIcon.module.scss'
import cx from 'classnames'
export const CollapseIcon = ({ open, onClick }) => {
  return (
    <button
      onClick={onClick}
      type='button'
      className={open ? cx(styles.sortOrderButton, styles.rotated) : styles.sortOrderButton}
    >
      <svg
        width='16'
        height='9'
        viewBox='0 0 16 9'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path d='M13.1753 0.386094L8.00193 5.55943L2.82859 0.386094C2.30859 -0.133906 1.46859 -0.133906 0.948594 0.386094C0.428594 0.906094 0.428594 1.74609 0.948594 2.26609L7.06859 8.38609C7.58859 8.90609 8.42859 8.90609 8.94859 8.38609L15.0686 2.26609C15.5886 1.74609 15.5886 0.906094 15.0686 0.386094C14.5486 -0.120573 13.6953 -0.133906 13.1753 0.386094Z' />
        <path
          d='M13.1753 0.386094L8.00193 5.55943L2.82859 0.386094C2.30859 -0.133906 1.46859 -0.133906 0.948594 0.386094C0.428594 0.906094 0.428594 1.74609 0.948594 2.26609L7.06859 8.38609C7.58859 8.90609 8.42859 8.90609 8.94859 8.38609L15.0686 2.26609C15.5886 1.74609 15.5886 0.906094 15.0686 0.386094C14.5486 -0.120573 13.6953 -0.133906 13.1753 0.386094Z'
          fill='black'
          fillOpacity='0.2'
        />
      </svg>
    </button>
  )
}
